import { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function EditQrModal({ entry, onClose, onSuccess }) {
  const [url, setUrl] = useState(entry.url);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState(entry.name);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.put(`/api/qr/${entry._id}`, { url, name }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      toast.success("Updated successfully!");
      onSuccess();
      onClose();
    } catch (err) {
      toast.error("Failed to update.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded shadow-md w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Edit Destination</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            placeholder="Enter name"
            className="input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="url"
            placeholder="Enter new URL"
            className="input"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            required
          />
          <div className="flex justify-end space-x-2">
            <button onClick={onClose} type="button" className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400">Cancel</button>
            <button disabled={loading} type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
